<template>
    <div class="v-distpicker" v-if="isShow">
        <div class="select-hd">
            <ul>
                <li v-bind:class="{cur: selectKey === 'p'}" @click="showP">{{province}}</li>
                <li v-bind:class="{cur: selectKey === 'c'}" v-if="cityList.length > 0" @click="showC">{{city}}</li>
                <li v-bind:class="{cur: selectKey === 'n'}" v-if="districtList.length > 0">{{district}}</li>
            </ul>
        </div>
        <div class="select-bd">
            <ul class="fix" v-if="selectKey === 'p'">
                <li v-for="(item, index) in provinceList" :key="index" @click="selectP(item)">
                    {{item.p}}
                </li>
                <li @click="closeLayer">稍后再说</li>
            </ul>
            <ul class="fix" v-if="selectKey === 'c'">
                <li v-for="(item, index) in cityList" :key="index" @click="selectC(item)">
                    {{item.n}}
                </li>
                <li @click="closeLayer">稍后再说</li>
            </ul>
            <ul class="fix" v-if="selectKey === 'n'">
                <li v-for="(item, index) in districtList" :key="index" @click="selectN(item)">
                    {{item.s}}
                </li>
                <li @click="closeLayer">稍后再说</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import distList from './city'
    export default {
        name: 'Distpicker',
        props: {
            isShow: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                provinceList: distList,
                cityList: [],
                districtList: [],
                province: '请选择',
                city: '请选择',
                district: '请选择',
                selectKey: 'p'
            }
        },
        methods: {
            closeLayer () {
                this.$emit('on-close', false)
            },
            showP () {
                this.selectKey = 'p'
                this.city = '请选择'
                this.district = '请选择'
                this.cityList = []
                this.districtList = []
            },
            showC () {
                this.selectKey = 'c'
                this.district = '请选择'
                this.districtList = []
            },
            selectP (item) {
                this.province = item.p
                this.cityList = item.c
                this.selectKey = 'c'
            },
            selectC (item) {
                this.city = item.n
                if (!item.a) {
                    this.$emit('on-close', false)
                    this.$emit('on-select', {
                        province: this.province,
                        city: this.city
                    })
                    return
                }
                this.districtList = item.a
                this.selectKey = 'n'
            },
            selectN (item) {
                this.district = item.s

                this.$emit('on-close', false)
                this.$emit('on-select', {
                    province: this.province,
                    city: this.city,
                    district: this.district
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .v-distpicker{
        position: absolute;
        left: 0;
        top: 44px;
        z-index: 1;
        width: 100%;
        padding: 6px 14px;
        background-color: #fff;
        border: #d3dadd solid 1px;
        border-top-width: 0;
        .select-hd{
            ul{
                height: 31px;
                border-bottom: #4a90e2 solid 1px;
                li{
                    float: left;
                    padding: 0 10px;
                    border: #d3dadd solid 1px;
                    border-bottom-width: 0;
                    background-color: #fff;
                    line-height: 29px;
                    color: #4a90e2;
                    cursor: pointer;
                    &.cur{
                        border-color: #4a90e2;
                        line-height: 30px;
                    }
                    &::after{
                        content: "";
                        display: inline-block;
                        width: 15px;
                        height: 9px;
                        margin-left: 3px;
                        background: url("../../assets/images/down_area.png") no-repeat center center;
                        background-size: 20px 20px;
                    }
                }
            }
        }
        .select-bd{
            ul{
                width: 100%;
                height: 170px;
                margin: 10px 0;
                overflow-y: scroll;
                li{
                    float: left;
                    width: 25%;
                    padding-right: 10px;
                    line-height: 34px;
                    cursor: pointer;
                    color: #919b9f;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    &:last-child{
                        color: #4a90e2;
                    }
                }
            }
        }
    }
</style>
